import { Outlet, useNavigate } from 'react-router-dom';
import { useRole, canExitToLauncher } from '../lib/role.tsx';

interface ModuleShellProps {
  title: string;
}

export function ModuleShell({ title }: ModuleShellProps) {
  const role = useRole();
  const navigate = useNavigate();
  const showExit = canExitToLauncher(role);

  return (
    <div className="flex flex-col min-h-screen">
      <header className="flex items-center h-12 px-4 border-b border-gray-200 relative">
        {showExit && (
          <button
            className="absolute left-4 text-sm text-mnp-stamp hover:underline"
            onClick={() => navigate('/')}
            aria-label="На главную"
          >
            ← На главную
          </button>
        )}
        <h1 className="mx-auto text-base font-semibold">{title}</h1>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
